import { PUBLIC_COMPS_APPROACH } from 'common/constants/calibration';
import { CustomValidationsParams } from '../types';

const customValidations = async (params: CustomValidationsParams) => {
  const { cell, addFeedback, removeFeedback } = params;
  if (cell?.alias === PUBLIC_COMPS_APPROACH) {
    if (cell?.value === 0) {
      addFeedback?.('Select Approach');
    } else {
      removeFeedback?.('Select Approach');
    }
  }
};

export default customValidations;
